import { StateCreator } from 'zustand';

export interface ConfigurationCriteriaProductsSlice {
  validSkus: string[];
  invalidSkus: string[];
  setValidSkus: (skus: string[]) => void;
  setInvalidSkus: (skus: string[]) => void;
  clearParsedSkus: () => void;
}

export const createConfigurationCriteriaProductsSlice: StateCreator<
  ConfigurationCriteriaProductsSlice
> = (set) => ({
  validSkus: [],
  invalidSkus: [],
  lastImportedSkus: [],
  setValidSkus: (skus) => set({ validSkus: skus }),
  setInvalidSkus: (skus) => set({ invalidSkus: skus }),
  clearParsedSkus: () => set({ validSkus: [], invalidSkus: [] }),
});
